<p-breadcrumb class="br-crumb" [model]="items">
     <ng-template pTemplate="separator"> / </ng-template>
</p-breadcrumb>